import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  doctors: [],
  customers: [],
  technics: [''],
  scrollPosition: 0,
  showCamera: false,
  showDoctorOrders: false
};

export const labSlice = createSlice({
  name: 'lab',
  initialState,
  reducers: {
    setShowDoctorOrders: (state, action) => {
      state.showDoctorOrders = action.payload;
    },
    setDoctors: (state, action) => {
      state.doctors = action.payload;
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    setTechnics: (state, action) => {
      state.technics = action.payload;
    },
    setScrollPosition: (state, action) => {
      state.scrollPosition = action.payload;
    },
    setShowCamera: (state, action) => {
      state.showCamera = action.payload;
    },
  },
});

export const {
  setShowDoctorOrders,
  setDoctors,
  setCustomers,
  setTechnics,
  setScrollPosition,
  setShowCamera,
} = labSlice.actions;

export const selectDoctors = (state) => state.lab.doctors;
export const selectCustomers = (state) => state.lab.customers;
export const selectTechnics = (state) => state.lab.technics;
export const selectScrollPosition = (state) => state.lab.scrollPosition;
export const selectShowCamera = (state) => state.lab.showCamera;
export const selectShowDoctorOrders = (state) => state.lab.showDoctorOrders;

export default labSlice.reducer;
